"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OcapiShopperBaskets = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _queryString = _interopRequireDefault(require("query-string"));
var _utils = require("./utils");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Copyright (c) 2022, salesforce.com, inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * SPDX-License-Identifier: BSD-3-Clause
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */ // This class allows integration with OCAPI Baskets Resource
// https://documentation.b2c.commercecloud.salesforce.com/DOC2/topic/com.demandware.dochelp/OCAPI/current/shop/Resources/Baskets.html
// This implementations coverts CAPI requests to OCAPI requests as there are fundamental differences between the APIS
// One major difference is OCAPI uses snake_case and CAPI uses camelCase for this reaso you will see a utility function in here that convert
// from camelCase to snake_case - camelCaseKeysToUnderscore
// createOcapiFetch is another utility function that returns the response from OCAPI in the fromat returned from CAPI
// Another utility function - checkRequiredParameters is used to check if the parameters or body objects necessary for a call are
// present in the request before making it
class OcapiShopperBaskets {
  constructor(config) {
    this.fetch = (0, _utils.createOcapiFetch)(config);
  }
  createBasket(...args) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const params = _objectSpread({}, args[0].parameters);
      // @ts-ignore
      return yield _this.fetch(`baskets?${_queryString.default.stringify(params)}`, 'POST', args, 'createBasket');
    })();
  }
  updateBasket(...args) {
    var _this2 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'body'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId
        },
        body
      } = args[0];
      // @ts-ignore
      return _this2.fetch(`baskets/${basketId}`, 'PATCH', args, 'updateBasket', body);
    })();
  }
  getBasket(...args) {
    var _this3 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      const {
        basketId
      } = args[0].parameters;
      // @ts-ignore
      return yield _this3.fetch(`baskets/${basketId}`, 'GET', args, 'getBasket');
    })();
  }
  addItemToBasket(...args) {
    var _this4 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'body'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId
        },
        body
      } = args[0];
      return _this4.fetch(`baskets/${basketId}/items`, 'POST', args, 'addToBasket', (0, _utils.camelCaseKeysToUnderscore)(body), true);
    })();
  }
  updateItemInBasket(...args) {
    var _this5 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'body'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId,
          itemId
        },
        body
      } = args[0];
      return _this5.fetch(`baskets/${basketId}/items/${itemId}`, 'PATCH', args, 'updateItemInBasket', (0, _utils.camelCaseKeysToUnderscore)(body), true);
    })();
  }
  removeItemFromBasket(...args) {
    var _this6 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'itemId'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      const {
        basketId,
        itemId
      } = args[0].parameters;
      // @ts-ignore
      return _this6.fetch(`baskets/${basketId}/items/${itemId}`, 'DELETE', args, 'removeItemFromBasket');
    })();
  }
  addGiftCertificateItemToBasket(...args) {
    var _this7 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'body'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId
        },
        body
      } = args[0];
      return _this7.fetch(`baskets/${basketId}/gift_certificate_items`, 'POST', args, 'addGiftCertificateItemToBasket', (0, _utils.camelCaseKeysToUnderscore)(body), true);
    })();
  }
  removeGiftCertificateItemFromBasket(...args) {
    var _this8 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'itemId'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      const {
        basketId,
        itemId
      } = args[0].parameters;
      // @ts-ignore
      return _this8.fetch(`baskets/${basketId}/gift_certificate_items/${itemId}`, 'DELETE', args, 'removeGiftCertificateItemFromBasket');
    })();
  }
  addPaymentInstrumentToBasket(...args) {
    var _this9 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'body'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId
        },
        body
      } = args[0];
      // @ts-ignore
      return _this9.fetch(`baskets/${basketId}/payment_instruments`, 'POST', args, 'addPaymentInstrumentToBasket', (0, _utils.camelCaseKeysToUnderscore)(body));
    })();
  }
  removePaymentInstrumentFromBasket(...args) {
    var _this10 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'paymentInstrumentId'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId,
          paymentInstrumentId
        }
      } = args[0];
      // @ts-ignore
      return _this10.fetch(`baskets/${basketId}/payment_instruments/${paymentInstrumentId}`, 'DELETE', args, 'removePaymentInstrumentFromBasket');
    })();
  }
  getPaymentMethodsForBasket(...args) {
    var _this11 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      const {
        basketId
      } = args[0].parameters;
      delete args[0].parameters.basketId;
      const params = _objectSpread({}, args[0].parameters);
      // @ts-ignore
      return _this11.fetch(`baskets/${basketId}/payment_methods?${_queryString.default.stringify(params)}`, 'GET', args, 'getPaymentMethodsForShipment');
    })();
  }
  getShippingMethodsForShipment(...args) {
    var _this12 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'shipmentId'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      const {
        basketId,
        shipmentId
      } = args[0].parameters;
      // @ts-ignore
      return _this12.fetch(`baskets/${basketId}/shipments/${shipmentId}/shipping_methods`, 'GET', args, 'getShippingMethodsForShipment');
    })();
  }
  updateBillingAddressForBasket(...args) {
    var _this13 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'body'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId,
          useAsShipping = false
        },
        body
      } = args[0];
      // @ts-ignore
      return _this13.fetch(`baskets/${basketId}/billing_address?use_as_shipping=${useAsShipping}`, 'PUT', args, 'updateBillingAddressForBasket', (0, _utils.camelCaseKeysToUnderscore)(body));
    })();
  }
  updateShippingAddressForShipment(...args) {
    var _this14 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'body', 'shipmentId'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId,
          shipmentId,
          useAsBilling = false
        },
        body
      } = args[0];
      // @ts-ignore
      return _this14.fetch(`baskets/${basketId}/shipments/${shipmentId}/shipping_address?use_as_billing=${useAsBilling}`, 'PUT', args, 'updateShippingAddressForShipment', (0, _utils.camelCaseKeysToUnderscore)(body));
    })();
  }
  updateShippingMethodForShipment(...args) {
    var _this15 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'body', 'shipmentId'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId,
          shipmentId
        },
        body
      } = args[0];
      // @ts-ignore
      return _this15.fetch(`baskets/${basketId}/shipments/${shipmentId}/shipping_method`, 'PUT', args, 'updateShippingMethodForShipment', (0, _utils.camelCaseKeysToUnderscore)(body));
    })();
  }
  updateShipment(...args) {
    var _this16 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'body', 'shipmentId'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId,
          shipmentId
        },
        body
      } = args[0];
      // @ts-ignore
      return _this16.fetch(`baskets/${basketId}/shipments/${shipmentId}`, 'PATCH', args, 'updateShipment', (0, _utils.camelCaseKeysToUnderscore)(body));
    })();
  }
  updateCustomerForBasket(...args) {
    var _this17 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'body'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId
        },
        body
      } = args[0];
      // @ts-ignore
      return _this17.fetch(`baskets/${basketId}/customer`, 'PUT', args, 'updateCustomerForBasket', (0, _utils.camelCaseKeysToUnderscore)(body));
    })();
  }
  deleteBasket(...args) {
    var _this18 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      const {
        basketId
      } = args[0].parameters;
      // @ts-ignore
      return _this18.fetch(`baskets/${basketId}`, 'DELETE', args, 'deleteBasket');
    })();
  }
  addCouponToBasket(...args) {
    var _this19 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'body'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId
        },
        body
      } = args[0];
      // @ts-ignore
      return _this19.fetch(`baskets/${basketId}/coupons`, 'POST', args, 'addCouponToBasket', (0, _utils.camelCaseKeysToUnderscore)(body));
    })();
  }
  removeCouponFromBasket(...args) {
    var _this20 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const required = ['basketId', 'couponItemId'];
      let requiredParametersError = (0, _utils.checkRequiredParameters)(args[0], required);
      if (requiredParametersError) {
        return requiredParametersError;
      }
      let {
        parameters: {
          basketId,
          couponItemId
        }
      } = args[0];
      // @ts-ignore
      return _this20.fetch(`baskets/${basketId}/coupons/${couponItemId}`, 'DELETE', args, 'removeCouponFromBasket');
    })();
  }
}
exports.OcapiShopperBaskets = OcapiShopperBaskets;